<template>
    <div>
        <div v-html="$t('intern_inserieren.paketwahl_titel')"></div>
        <table class="packet-table my-5" v-if="types && user && !isMobile">
            <thead>
                <tr>
                    <th colspan="1" style="background-color: #FFF;">&nbsp;</th>
                    <th style="white-space: nowrap" v-for="quota in quotas" :key="quota">
                        {{quota}}
                        <template v-if="quota > 1">
                            {{$t('intern_inserieren.inserate')}}
                        </template>
                        <template v-else>
                            {{$t('intern_inserieren.inserat')}}
                        </template>
                    </th>
                    <th>ab 6 Inserate</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="duration in durations" :key="duration" >
                    <td style="white-space: nowrap">
                        {{duration}}
                        <template v-if="duration > 1">
                            {{$t('intern_inserieren.monate')}}
                            <span style="font-size:12px; color:#FF950B; width:100%; float:left;">
                            {{$t('intern_inserieren.sparen_laufzeit_'+duration)}}
                            </span>
                        </template>
                        <template v-else>
                            {{$t('intern_inserieren.monat')}}
                            <span style="font-size:12px; color:#FF950B; width:100%; float:left;">&nbsp;</span>
                        </template>
                    </td>
                    <!-- for new packets -->
                    <template v-if="packet_type == 'new'">
                        <td
                            v-for="type in types.filter(type => type.duration == duration)"
                            class="packet"
                            :class="{
                                active: active == type.id,
                                disabled: checkIfDisabled(type)}"
                            @click="selectPacket(type.id)">
                            {{type.price | currency}}
                            <div class="font-10">
                                {{$t('intern_inserieren.gesamtpreis')}}
                            </div>
                        </td>
                    </template>
                    <!-- for upgrading packets -->
                    <template v-else>
                        <td
                            v-for="type in types.filter(type => type.duration == duration)"
                            class="packet"
                            :class="{
                                active: active == type.id,
                                disabled: checkIfDisabled(type)
                            }"
                            @click="selectPacket(type.id, checkIfDisabled(type))">
                            {{type.price | currency}}
                            <div class="font-10">
                                {{$t('intern_inserieren.gesamtpreis')}}
                            </div>
                        </td>
                    </template>

                  <!-- Veratung anfordern -->
                    <td colspan="4">
                        <a  class="normal-a"
                            href="/vermieten"
                            target="_blank"
                        >
                            {{$t('intern_inserieren.beratung_anfordern')}}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>

        <!--commented for the new law (online booking for 1 month only)-->
        <!--<table class="packet-table my-5" v-if="types && user && !isMobile">
            <thead>
                <tr>
                    <th colspan="1" style="background-color: #FFF;">&nbsp;</th>
                    <th v-for="duration in durations" :key="duration">
                        {{duration}}
                        <template v-if="duration > 1">
                            {{$t('intern_inserieren.monate')}}
                            <span style="font-size:12px; color:#FF950B; width:100%; float:left;">
                            {{$t('intern_inserieren.sparen_laufzeit_'+duration)}}
                            </span>
                        </template>
                        <template v-else>
                            {{$t('intern_inserieren.monat')}}
                            <span style="font-size:12px; color:#FF950B; width:100%; float:left;">&nbsp;</span>
                        </template>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="quota in quotas" :key="quota">
                    <td style="white-space: nowrap">
                        {{quota}}
                        <template v-if="quota > 1">
                            {{$t('intern_inserieren.inserate')}}
                        </template>
                        <template v-else>
                            {{$t('intern_inserieren.inserat')}}
                        </template>
                    </td>
                    &lt;!&ndash; for new packets &ndash;&gt;
                    <template v-if="packet_type == 'new'">
                        <td
                            v-for="type in types.filter(type => type.quota == quota)"
                            class="packet"
                            :class="{
                                active: active == type.id,
                                disabled: checkIfDisabled(type)}"
                            @click="selectPacket(type.id)">
                            {{type.price | currency}}
                            <div class="font-10">
                                {{type.price * type.duration | currency}} {{$t('intern_inserieren.gesamtpreis')}}
                            </div>
                        </td>
                    </template>
                    &lt;!&ndash; for upgrading packets &ndash;&gt;
                    <template v-else>
                        <td
                            v-for="type in types.filter(type => type.quota == quota)"
                            class="packet"
                            :class="{
                                active: active == type.id,
                                disabled: checkIfDisabled(type)
                            }"
                            @click="selectPacket(type.id, checkIfDisabled(type))">
                            {{type.price | currency}}
                            <div class="font-10">
                                {{type.price * type.duration | currency}} {{$t('intern_inserieren.gesamtpreis')}}
                            </div>
                        </td>
                    </template>
                </tr>
                &lt;!&ndash; Veratung anfordern &ndash;&gt;
                <tr>
                    <td>ab 6 Inserate</td>
                    <td colspan="4">
                        <a  class="normal-a"
                            href="/vermieten"
                            target="_blank"
                        >
                            {{$t('intern_inserieren.beratung_anfordern')}}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>-->
        <table class="packet-table my-5" v-if="types && user && isMobile">
            <thead>
                <tr>
                    <th colspan="1" style="background-color: #FFF;">&nbsp;</th>
                    <th class="position-relative">
                        {{selectedDuration}}
                        <template v-if="selectedDuration > 1">
                            {{$t('intern_inserieren.monate')}}
                            <span style="font-size:12px; color:#FF950B; width:100%; float:left;">
                            {{$t('intern_inserieren.sparen_laufzeit_' + selectedDuration)}}
                            </span>
                        </template>
                        <template v-else>
                            {{$t('intern_inserieren.monat')}}
                            <span style="font-size:12px; color:#FF950B; width:100%; float:left;">&nbsp;</span>
                        </template>
<!--                        <font-awesome-icon icon="chevron-down" class="pointer" @click="hide_duration_selection = !hide_duration_selection"/>-->
                        <transition name="fade" mode="out-in">
                            <ul class="list-group select-duration" v-if="hide_duration_selection">
                                <li
                                    class="list-group-item"
                                    v-for="duration in durations"
                                    :key="duration"
                                    v-if="duration != selectedDuration"
                                    @click="selectDuration(duration)"
                                >
                                    {{duration}}
                                    <template v-if="duration > 1">
                                        {{$t('intern_inserieren.monate')}}
                                        <span style="font-size:12px; color:#FF950B; width:100%; float:left;">
                                        {{$t('intern_inserieren.sparen_laufzeit_' + duration)}}
                                        </span>
                                    </template>
                                    <template v-else>
                                        {{$t('intern_inserieren.monat')}}
                                        <span style="font-size:12px; color:#FF950B; width:100%; float:left;">&nbsp;</span>
                                    </template>
                                </li>
                            </ul>
                        </transition>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="quota in quotas" :key="quota">
                    <td style="white-space: nowrap">
                        {{quota}}
                        <template v-if="quota > 1">
                            {{$t('intern_inserieren.inserate')}}
                        </template>
                        <template v-else>
                            {{$t('intern_inserieren.inserat')}}
                        </template>
                    </td>
                    <!-- for new packets -->
                    <template v-if="packet_type == 'new'">
                        <td
                            v-for="type in types.filter(type => type.quota == quota && type.duration == selectedDuration)"
                            class="packet"
                            :class="{active: active == type.id}"
                            @click="selectPacket(type.id)">
                            {{type.price | currency}}
                            <div class="font-10">
                                {{$t('intern_inserieren.gesamtpreis')}}
                            </div>
                        </td>
                    </template>
                    <!-- for upgrading packets -->
                    <template v-else>
                        <td
                            v-for="type in types.filter(type => type.quota == quota && type.duration == selectedDuration)"
                            class="packet"
                            :class="{
                                active: active == type.id,
                                disabled: checkIfDisabled(type)
                            }"
                            @click="selectPacket(type.id, checkIfDisabled(type))">
                            {{type.price | currency}}
                            <div class="font-10">
                                {{$t('intern_inserieren.gesamtpreis')}}
                            </div>
                        </td>
                    </template>
                </tr>
                <!-- Veratung anfordern -->
                <tr>
                    <td>ab 6 Inserate</td>
                    <td colspan="4" style="white-space: nowrap">
                        <a  class="normal-a"
                            href="/vermieten"
                            target="_blank"
                        >
                            {{$t('intern_inserieren.beratung_anfordern')}}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-html="$t('intern_inserieren.monatlich_inkl_mwst')"></div>
    </div>
</template>

<script>
    import Booking           from '../../../classes/Booking';
    import EventBus          from '../../../EventBus';
    import { IsMobileMixin } from '../../../mixins/IsMobile';

    export default {
        data() {
            return {
                user: this.$store.state.user,
                quotas: null,
                durations: null,
                types: null,
                active: null,
                tabName: 'PACKET_CHOICE',
                selectedDuration: 1,
                hide_duration_selection: false
            }
        },
        props: {
            packet_type: {
                default: 'new'
            }
        },
        mixins: [IsMobileMixin],
        methods: {
            fetchAvaialablePackets() {
                this.$store.state.loading = true;
                this.$http.get('/buchungApi/getAvailablePackets').then( response => {
                    let data = JSON.parse(response.data);

                    this.durations = data.durations.map( item => item.duration );
                    this.quotas    = data.quotas.map( item => item.quota );
                    this.types     = data.types;
                    this.$store.state.loading = false;

                    if(this.isMobile){
                        this.durations = this.durations.sort((a, b) => {
                            a = Number(a);
                            b = Number(b);
                            if(a > b){
                                return -1;
                            }else if(a < b){
                                return 1;
                            }else {
                                return 0;
                            }
                        })
                    }
                    
                    if(this.active == null && this.types != null && this.packet_type == 'new'){
                        this.active = this.types[8].id;
                    }

                    if(this.packet_type != 'new'){
                        let allDisabled = this.types.every( type => this.checkIfDisabled(type));
                        if(allDisabled || !this.user.packet ) {
                            this.$emit('no_packet');
                        }
                    }
                }).catch( error => {
                    this.$store.state.loading = false;
                    this.$emit('error', 'Fehler, bitte versuchen Sie nochmal');
                });
            },
            selectPacket(packet_id, disabled = false){
                if(!disabled){
                    this.active= packet_id;
                    if(this.packet_type != 'new'){
                        this.$emit('selectPacket', this.active);
                    }
                }
            },
            selectDuration(duration) {
                this.selectedDuration = duration;
                this.hide_duration_selection = false;
            },
            checkIfDisabled(type) {
                return (
                    Number(type.duration) >= 3 //this check has been made becasue of Law change for one month booking only//
                    ||
                    Number(this.user.packet.quota) >= Number(type.quota)
                    ||
                    Number(this.user.packet.duration) > Number(type.duration)
                    ||
                    this.user.packet.name == type.name
                );
            },
            weiter(tab) {
                if(tab === this.tabName){
                    let booking = new Booking;

                    if(this.$cookies.isKey('currentBooking')){
                        booking = Booking.getObjectFromJSON(this.$cookies.get('currentBooking'));
                    }

                    booking.setPacket(this.types.find( item => this.active == item.id));
                    booking.setActiveTab('improvement');
                    this.$emit('nextTab', booking);
                }
            }
        },
        created() {
            this.fetchAvaialablePackets();

            if(this.$cookies.isKey('currentBooking')) {
                let booking = this.$cookies.get('currentBooking');
                this.active = booking.packet.id;
            }

            this.$store.watch( () => this.$store.getters.user , user => {
                this.user = user;
            });

            EventBus.$on('NEXT_EMIT_TO_CHILD', this.weiter);
        },
        beforeDestroy () {
            EventBus.$off('NEXT_EMIT_TO_CHILD', this.weiter);
        },
    }
</script>

<style scoped>
.packet-table{
    width: 100%;
}
.packet-table tr th, .packet-table tr td {
    width: 20%;
    text-align: center;
    padding: 20px 5px;
    background: #CFE5D0;
    font-weight: bold;
    border: 2px solid white;
}
.packet:hover{
    background: #FFFFFF;
    cursor: pointer;
}
.packet.active{
    background-color: #FF950B;
    color: white;
}
.normal-a {
    color: black;
}
.normal-a:hover {
    color: #5FA963;
}
.disabled{
    background-color: rgb(153, 153, 153) !important;
    color: #ccc;
    cursor: not-allowed !important;
}
.select-duration{
    position: absolute;
    top: 70px;
    right: 0;
    left: 0;
}
.select-duration li{
    cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
